import script from "./botao-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./botao-menu.vue?vue&type=script&setup=true&lang=js"

import "./botao-menu.vue?vue&type=style&index=0&id=0693f9be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0693f9be"]])

export default __exports__